<div class="backup-schedules-container">
    <div class="view-title">
        <h3>Scheduled backups</h3>
        <button (click)="createSchedule()" class="button mini">
            <mat-icon>add</mat-icon>
            Create
        </button>
    </div>
    <div class="backup-table">
        <div *ngFor="let schedule of backupSchedules" (click)="toggleSchedule(schedule)" (keydown)="toggleSchedule(schedule)" class="backup-row">
            <div class="row-header">
                <span><mat-icon class="status-icon" [ngClass]="{'enabled': schedule.enabled}">circle</mat-icon>{{schedule.name}}</span>
                <div>
                    <button [disabled]="actionPending()" click-stop-propagation (click)="runSchedule(schedule)" class="button outline mini">
                        <mat-icon>flash_on</mat-icon>
                        Run
                    </button>
                    <button [disabled]="actionPending()" click-stop-propagation (click)="toggleStopSchedule(schedule)" class="button outline mini">
                        <mat-icon *ngIf="schedule.enabled">pause</mat-icon>
                        <mat-icon *ngIf="!schedule.enabled">play_arrow</mat-icon>
                        {{schedule.enabled === true ? 'Disable': 'Enable'}} schedule
                    </button>
                    <button [disabled]="actionPending()" click-stop-propagation (click)="editSchedule(schedule)" class="button outline mini">
                        <mat-icon>edit</mat-icon>
                        Edit
                    </button>
                    <button [disabled]="actionPending()" click-stop-propagation (click)="deleteSchedule(schedule)" class="button outline mini">
                        <mat-icon>remove</mat-icon>
                        {{deleting? 'Deleting...' : 'Delete'}}
                    </button>
                </div>
            </div>
            <div class="main-data">
                <div class="column">
                    <span>Name</span>
                    <span>{{schedule.name}}</span>
                </div>
                <div class="column">
                    <span>Storage</span>
                    <span>{{schedule.storageDevice?.name}}</span>
                </div>
                <div class="column">
                    <span>Schedule time</span>
                    <span>{{schedule.hour | number:'2.0' }}:{{schedule.minute | number:'2.0' }}</span>
                </div>
                <div class="column">
                    <span>Status</span>
                    <span>{{schedule.enabled ? 'Enabled' : 'Disabled'}}</span>
                </div>
                <div class="column">
                    <span></span>
                    <span *ngIf="schedule.opened">
                        <mat-icon>arrow_drop_up</mat-icon>
                        View less
                    </span>
                    <span *ngIf="!schedule.opened">
                        <mat-icon>arrow_drop_down</mat-icon>
                        View more
                    </span>
                </div>
            </div>
            <div class="additional-data" [ngClass]="{'hidden': !schedule.opened}">
                <div>
                    <span class="title">Schedule backup path</span>
                    <div class="mb-3">
                        <span>{{schedule.path ?? '(not defined)'}}</span>
                    </div>
                </div>
                <div>
                    <span class="title">Schedule days</span>
                    <div class="schedule-days">
                        <div class="day" *ngFor="let day of daysOfWeek; index as i">
                            <mat-icon class="day-icon">{{isScheduleDayActive(schedule, i)? 'circle': 'radio_button_unchecked'}}</mat-icon>
                            <span>{{day}}</span>
                        </div>
                    </div>
                </div>
                <div>
                    <span *ngIf="!!schedule.storageDevice" class="title">Storage devices</span>
                    <div *ngIf="!!schedule.storageDevice" class="storage-devices-list">
                        <div class="device-row">
                            <div class="column">
                                <span>ID</span>
                                <span>{{schedule.storageDevice.id}}</span>
                            </div>
                            <div class="column">
                                <span>Address</span>
                                <span>{{schedule.storageDevice.address}}</span>
                            </div>
                            <div class="column">
                                <span>Type</span>
                                <span>{{getDeviceTypeString(schedule.storageDevice.type)}}</span>
                            </div>
                            <div class="column">
                                <span>User</span>
                                <span>{{schedule.storageDevice.user ?? '-'}}</span>
                            </div>
                            <div class="column">
                                <span>Root folder</span>
                                <span>{{schedule.storageDevice.rootFolder}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
